import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import NotificationAnalytics from '~/analytics/notification/notificationAnalytics'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { setIsNotificationListOpen } from '~/gamification/slices/gamification.slice'
import { useGetBadgesQuery } from '~/redux/apis/collection-api'
import { useSetMarkAsReadMutation } from '~/redux/apis/notification-api'
import { useAppDispatch } from '~/redux/hooks'
import ROUTES from '~/shared/constants/routes.const'
import { setShowcaseBadge } from '~/redux/slices/homebase'
import { NotificationMessage } from '~/shared/types/notification.types'
import { COLLECTION_LIST } from '~/types/homebaseQuiz.types'

export default function BadgeUnlockNotification({
  message,
  id,
  isRead,
}: {
  message: NotificationMessage
  id: number
  isRead: boolean
}): React.ReactElement {
  const { t } = useTranslation('gamification')
  const { data: badgeData } = useGetBadgesQuery(null)
  const badge = badgeData?.find((data) => data.metadata.subjectId === message.subject)
  const dispatch = useAppDispatch()
  const [setMarkAsRead] = useSetMarkAsReadMutation()
  const router = useRouter()

  const onClick = (): void => {
    NotificationAnalytics.logNotificationClick(message.title, { subject: message.subject as string })
    if (!isRead) {
      setMarkAsRead({ notificationIds: [id] })
    }
    dispatch(setIsNotificationListOpen(false))
    dispatch(
      setShowcaseBadge({
        subject: message.subject || '',
        category: message.category,
        collection: COLLECTION_LIST.BOOTCAMP,
        badgeData: badge,
      }),
    )
    // The collection lives on its own page now, so the badge is shown there rather than in a modal.
    router.push(ROUTES.ACHIEVEMENTS_LEGACY)
  }
  return (
    <button className="relative flex flex-col w-full" onClick={onClick}>
      <div className="flex pt-2 items-center">
        {message.image_path && (
          <ResponsiveImage
            className="min-w-max px-5"
            fit="contain"
            height={56}
            imageWidths="56"
            srcKey={message.image_path}
            width={56}
          />
        )}
        <div className="pr-2 text-left">
          <h3 className="font-semibold text-md uppercase">{t('badgeUnlock')}</h3>
          <p className="text-sm">{t('bossDefeated')}</p>
        </div>
      </div>
      {!isRead && (
        <div className="absolute flex justify-center items-center right-3 -bottom-3">
          <span className="animate-ping absolute inline-flex rounded-full bg-purple-bright opacity-75 w-3.5 h-3.5" />
          <span className="absolute flex justify-center items-center rounded-full bg-purple w-2.5 h-2.5 text-xxs font-semibold" />
        </div>
      )}
    </button>
  )
}
